import { render, staticRenderFns } from "./InternalRequestDrawer.vue?vue&type=template&id=a8f52976&"
import script from "./InternalRequestDrawer.vue?vue&type=script&lang=js&"
export * from "./InternalRequestDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InternalRequestDrawer.vue?vue&type=style&index=0&id=a8f52976&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports